module.exports = ".count{\r\n   /* width:50px;*/\r\n     width: 68px;\r\n    border:1px solid #ccc;\r\n    padding:3px 12px;\r\n}\r\n\r\n.awards td.width40{\r\n    width:40%;\r\n}\r\n\r\n.form-check label{\r\n    font-size:14px !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/sainik-registration/awards/awards.component.css
// module id = ./src/app/sainik-registration/awards/awards.component.css
// module chunks = main